import type { MetadataRoute } from "next";
import urlJoin from "url-join";
import { z } from "zod";

import { env } from "@/env";

import { rewriteUrls } from "../../rewriteUrls/rewriteUrls";

export const additionalLanguageLinksSchema = z.array(
  z.object({
    link: z
      .object({
        model: z.string(),
        value: z.object({
          query: z.array(
            z.object({
              property: z.literal("locale"),
              operator: z.literal("is"),
              value: z.array(z.string()),
            })
          ),
          data: z.object({
            slug: z.string(),
          }),
        }),
      })
      .passthrough(),
  })
);

export type AdditionalLanguageLinks = z.infer<typeof additionalLanguageLinksSchema>;

export const getBlogArticleAlternates = (
  additionalLanguageLinks: unknown,
  slug: string
): NonNullable<MetadataRoute.Sitemap[number]["alternates"]> | undefined => {
  if (!additionalLanguageLinks) {
    return undefined;
  }

  const parsed = additionalLanguageLinksSchema.safeParse(additionalLanguageLinks);

  if (!parsed.success) {
    return undefined;
  }

  const languages: Record<string, string> = {};

  for (const item of parsed.data) {
    const query = item.link.value.query;
    const locale = query.find(({ property }) => property === "locale")?.value?.[0];

    if (locale) {
      const url = item.link.value.data.slug;
      if (url) {
        const blogSlug = rewriteUrls(urlJoin("/", slug, url), locale);
        languages[locale] = urlJoin(env.siteUrl, locale, blogSlug);
      }
    }
  }

  return Object.keys(languages).length > 0 ? { languages } : undefined;
};
